import type { CMD, NS, ShortcutItem, ShortcutMap } from '@/package';

/**
 * @param data - Maybe ShortcutMap
 * @returns ShortcutMap or throw error
 */
export const isValidShortcutMap = (data: unknown): ShortcutMap<NS, CMD> => {
  const assert = (condition: boolean) => {
    if (!condition) throw new Error();
  };

  assert(typeof data === 'object' && data !== null);

  const shortcutMap = data as Record<string, unknown>;
  const nameSpaceList = Object.keys(shortcutMap);

  assert(Array.isArray(nameSpaceList));

  for (const namespace of nameSpaceList) {
    const items = shortcutMap[namespace];
    assert(Array.isArray(items));

    const shortcutItemList = items as ShortcutItem<CMD>[];
    for (const item of shortcutItemList) {
      assert(typeof item === 'object' && item !== null);

      const shortcutItem = item as Record<string, unknown>;
      assert(
        typeof shortcutItem.command === 'string' &&
          Array.isArray(shortcutItem.key) &&
          typeof shortcutItem.category === 'string',
      );
    }
  }

  return shortcutMap as ShortcutMap<NS, CMD>;
};
